// @flow
import { call, put, takeLatest, select } from 'redux-saga/effects';
import {
  getWebinarListApi,
  getWebinarEntityCode,
  getWebinarList,
  getWebinarFeatureId,
  getCwpWebinarListApi,
} from '../selectors/webinarSelectors';
import {
  FETCH_WEBINAR_LIST_REQUEST,
  FETCH_WEBINAR_LIST_SUCCESS,
  disableWebinarRedDot,
  enableWebinarRedDot,
  fetchWebinarListRequest,
  PUT_WEBINAR_RED_DOT,
} from '../actions/webinarActions';
import {
  checkDisplayWebinarRedDot,
  getDisplayRedDotWebinarEvent,
} from '../utils/webinarRedDotUtil';
import { v4 as uuidv4 } from 'uuid';
import { getCustomerPolicies } from '../../../selectors/userSelectors';
import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
import { FETCH_CUSTOMER_SUCCESS } from '../../../actions/userActions';
import { getMuleRedDotState } from '../../home/selectors/muleCustStateSelectors';
import {
  FETCH_MULE_RED_DOT_STATE_SUCCESS,
  updateMuleRedDotState,
} from '../../home/actions/muleCustStateActions';
import _ from 'lodash';

function* finishFetchCustomer(action: any): any {
  yield put(fetchWebinarListRequest());
}
function* fetchWebinarList(action: any): any {
  console.log(`fetchWebinarList ${action.type}:`);
  try {
    const allPolicies = yield select(getCustomerPolicies);
    const webinarListUrl = yield select(getWebinarListApi);
    const cwpWebinarListUrl = yield select(getCwpWebinarListApi);
    const webinarEntityCode = yield select(getWebinarEntityCode);

    if (!webinarListUrl) {
      return;
    }

    // If CWP, no query string. If life/eb, pass all policy number.
    const allPolicyNumbersQueryVal = allPolicies
      .filter((p: any) => webinarEntityCode.includes(p.entityCode))
      .map((p: any) => p.policyNumber)
      .join(','); // Joined in string

    let url = '';
    if (!allPolicyNumbersQueryVal) {
      url = cwpWebinarListUrl;
    } else {
      // If only one entity code, use that one. If more than one, use 'ALL'.
      const allEntityCodes = allPolicies
        .filter((p: any) => webinarEntityCode.includes(p.entityCode))
        .map((p: any) => p.entityCode);
      const deduplicatedAllEntityCode = _.uniq(allEntityCodes);
      const entityCodeQueryVal =
        deduplicatedAllEntityCode.length === 1
          ? deduplicatedAllEntityCode[0]
          : 'ALL';

      url = webinarListUrl
        .replace(`\${policyNumber}`, allPolicyNumbersQueryVal)
        .replace(`\${entityCode}`, entityCodeQueryVal);
    }

    const res = yield call(myAxaFetchWithToken, url, {
      method: 'GET',
      headers: { 'x-axahk-msgid': uuidv4() },
    });
    if (res && res.status === 200) {
      const data = yield res.json();
      if (data?.code && data.code === '500') {
        throw new Error('API Error Status 500');
      }
      yield put({
        type: action.succcessAction,
        payload: data,
      });
    } else {
      throw res;
    }
  } catch (e) {
    yield put({ type: action.failureAction, payload: e });
  }
}

function* proceedWebinarRedDot(action: any): any {
  const muleRedDotState = yield select(getMuleRedDotState);
  const webinarListResponse = yield select(getWebinarList);
  const isDisplayWebinarRedDot = checkDisplayWebinarRedDot(
    muleRedDotState,
    webinarListResponse,
  );
  if (isDisplayWebinarRedDot) {
    yield put(enableWebinarRedDot());
  } else {
    yield put(disableWebinarRedDot());
  }
}

function* onWebinarOpen(action: any): any {
  const { payload } = action;
  const { featureId } = payload;

  // ONLY for webinar
  const webinarFeatureId = yield select(getWebinarFeatureId);
  if (featureId !== webinarFeatureId) {
    return;
  }

  const muleRedDotState = yield select(getMuleRedDotState);
  const webinarListResponse = yield select(getWebinarList);
  const redDotWebinarEvents = getDisplayRedDotWebinarEvent(
    muleRedDotState,
    webinarListResponse,
  );
  const redDotWebinarEventIds = redDotWebinarEvents.map(
    (i) => `${webinarFeatureId}:${i.campaignId}`,
  );
  if (redDotWebinarEventIds.length > 0) {
    yield put(updateMuleRedDotState(redDotWebinarEventIds));
  }
}

function* webinarSaga(): any {
  yield takeLatest(FETCH_CUSTOMER_SUCCESS, finishFetchCustomer);
  yield takeLatest(FETCH_WEBINAR_LIST_REQUEST, fetchWebinarList);
  yield takeLatest(FETCH_WEBINAR_LIST_SUCCESS, proceedWebinarRedDot);
  yield takeLatest(FETCH_MULE_RED_DOT_STATE_SUCCESS, proceedWebinarRedDot);
  yield takeLatest(PUT_WEBINAR_RED_DOT, onWebinarOpen);
}

export { webinarSaga };
